// Decides whether the "allow browser notifications" banner should be shown.
// The browser only remembers a granted/denied answer; "not now" and "don't ask
// again" live in the user's settings so they follow the user across devices.

export const NOTIFICATION_PROMPT_SNOOZE_DAYS = 30;

export const isNotificationSupported = () =>
  typeof window !== 'undefined' && 'Notification' in window;

export const getNotificationPermission = () =>
  isNotificationSupported() ? Notification.permission : 'unsupported';

export const snoozeUntilDate = (now = Date.now()) =>
  new Date(
    now + NOTIFICATION_PROMPT_SNOOZE_DAYS * 24 * 60 * 60 * 1000
  ).toISOString();

export const shouldShowNotificationPrompt = (userSetting, now = Date.now()) => {
  if (getNotificationPermission() !== 'default') {
    return false;
  }
  if (userSetting?.notificationPromptDismissed) {
    return false;
  }
  const snoozedUntil = userSetting?.notificationPromptSnoozedUntil;
  if (snoozedUntil && new Date(snoozedUntil).getTime() > now) {
    return false;
  }
  return true;
};
